import { InjectionToken } from '@angular/core';
import { ThemePreference } from '../interfaces/theme-preference.interface';

/**
 * No root factory: the implementation lives next to the data slice. That
 * slice registers it on the root injector.
 */
export const THEME_PREFERENCE = new InjectionToken<ThemePreference>('ThemePreference');
